import React, { useMemo, useState } from "react";
import StripePayment from "./StripePayment";
import ModalSkeleton from "components/Modals/ModalSkeleton";
import CustomButton from "components/common/Button/CustomButton";
import { useSelector } from "react-redux";
import { getStripeSaveCardDataLoader } from "store/selector/sp.selector";
import CardList from "./Card/CardList";
import CircularLoader from "components/common/CircularLoader/CircularLoader";
import { capitalizeFirstLetter } from "Utils/utils";
import useDefaultPaymentMethod from "hooks/useDefaultPaymentMethod";
// import {
//   BILLING_BREADCRUMB,
//   BILLING_BREADCRUMB_PAGES,
// } from "Constants/BreadcrumbConstant";
// import SideBarNew from "components/common/SideBar/SideBarNew";
// import { LoginContext } from "helpers/LoginContext";
// import Header from "components/common/Header/Header";
// import Breadcrumb from "components/common/Breadcrumb";
// import { BiExit } from "react-icons/bi";
// import { callLogout } from "store/actions/auth.actions";
// import { useNavigate } from "react-router";

const PaymentMethod = ({ istrailExpired = false }) => {
  const [openPaymentModal, setOpenPaymentModal] = useState(false);
  const saveCardDataLoader = useSelector(getStripeSaveCardDataLoader);
  // const { sideBarPadding } = useContext(LoginContext);

  // const navigate = useNavigate();
  // const dispatch = useDispatch();

  const {
    getDefaultCardDetails,
    stripeDefaultPaymentMethodLaoder,
    paymentSettings,
    cardsListData,
  } = useDefaultPaymentMethod();

  const defaultCardDetails = useMemo(() => {
    return getDefaultCardDetails;
  }, [
    paymentSettings,
    stripeDefaultPaymentMethodLaoder,
    saveCardDataLoader,
    getDefaultCardDetails,
  ]);

  // const handleLogout = () => {
  //   localStorage.clear();
  //   sessionStorage.clear();
  //   dispatch(callLogout());
  //   navigate("/");
  // };

  return (
    <>
      <div className='min-h-full'>
        {/* {istrailExpired === false && <SideBarNew />}
        <main>
          <div
            className={classNames(
              istrailExpired === false
                ? sideBarPadding
                  ? "lg:pl-[4rem] duration-300"
                  : "lg:pl-64 duration-300"
                : "",
              `${sideBarPadding} flex flex-col fullScreenHeight`
            )}
          >
            {istrailExpired === false ? (
              <Header title='Billing Method' cssClass={"z-[10]"} />
            ) : (
              <header className='bg-white flex items-center sticky top-0 z-[10] border-b border-gray-200 sm:px-6 lg:px-8 py-[20px] h-[80px]'>
                <div className='items-center w-full flex sm:flex sm:items-center sm:justify-between'>
                  <div className='flex-1 min-w-0'>
                    <h1 className='text-xl font-semi bold text-gray-900 capitalize'>
                      Billing Method
                    </h1>
                  </div>
                  <div className='mt-4 flex justify-space-between sm:mt-0 space-x-2 print:hidden'>
                    <div className='md:mt-0 md:ml-auto space-x-2 md:space-x-4 hidden sm:flex'>
                      <CustomButton
                        clickHandler={handleLogout}
                        label={"Logout"}
                        Icon={<BiExit />}
                        variant={"danger"}
                      />
                    </div>
                  </div>
                </div>
              </header>
            )}
            <div className='px-4 py-2'>
              <div className='mb-5 border-gray-200 px-4 pt-4'>
                <Breadcrumb
                  pages={BILLING_BREADCRUMB(
                    BILLING_BREADCRUMB_PAGES.BILLING_METHOD
                  )}
                />
              </div>
              <div
                style={{ paddingTop: "15px", top: "70px" }}
                className='px-6 flex flex-col sm:flex-row justify-between items-center pb-4'
              >
                <p className='font-bold text-xl'>Billing Method</p>
                <div>
                  <CustomButton
                    isDisabled={saveCardDataLoader}
                    showLoading={saveCardDataLoader}
                    label='Add Card'
                    clickHandler={() => setOpenPaymentModal(true)}
                  />
                </div>
              </div>
              <div className='px-6 pb-4 py-4 ring-1 ring-black ring-opacity-5 md:rounded-lg mb-4'>
                <div className='flex justify-between items-center py-2'>
                  <p className='text-md font-bold'>Card List</p>
                </div>
                <div className={`w-full py-2 rounded-lg`}>
                  <CardList cards={cardsListData} />
                </div>
              </div>
              <>
                {defaultCardDetails !== null && (
                  <div className='px-6 py-4 bg-gray-50 md:rounded-lg ring-1 ring-black ring-opacity-5'>
                    <div className='flex justify-between items-center py-2'>
                      <p className='text-md font-bold'>Default Card Details</p>
                    </div>
                    <>
                      {stripeDefaultPaymentMethodLaoder ? (
                        <CircularLoader
                          classes='flex justify-center items-center'
                          classloader='loader-l'
                        />
                      ) : (
                        <div
                          className={`w-full py-2 grid gap-6 md:rounded-lg lg:grid-cols-2 md:grid-cols-1 sm:grid-cols-1`}
                        >
                          {defaultCardDetails !== null ? (
                            <>
                              <div>
                                <InputField
                                  label='Card Number'
                                  type='text'
                                  isDisabled={true}
                                  value={`**** **** **** ${defaultCardDetails?.last4}`}
                                />
                              </div>
                              <div>
                                <InputField
                                  label='Name On Card'
                                  type='text'
                                  isDisabled={true}
                                  value={capitalizeFirstLetter(
                                    defaultCardDetails?.card_name
                                  )}
                                />
                              </div>
                              <div>
                                <InputField
                                  label='Expiry Date'
                                  type='text'
                                  isDisabled={true}
                                  value={`${defaultCardDetails?.exp_month}/${defaultCardDetails?.exp_year}`}
                                />
                              </div>
                            </>
                          ) : (
                            <div className='col-span-2 w-full bg-gray-50 px-5 py-4'>
                              <div className='text-red-500 text-center'>
                                No Data Found!
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                    </>
                  </div>
                )}
              </>
            </div>
          </div>
        </main> */}

        <div className='relative bg-slate-50/80 border border-slate-200/60 p-4 sm:p-6 rounded-xl mb-8 shadow-sm'>
          <div className='relative'>
            <div className='flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6'>
              <div>
                <h2 className='text-lg font-semibold text-slate-800'>Your payment methods</h2>
                <p className='text-sm text-slate-500 mt-0.5'>Manage cards used for subscription billing.</p>
              </div>
              <CustomButton
                cssClass='w-max rounded-lg'
                isDisabled={saveCardDataLoader}
                showLoading={saveCardDataLoader}
                label='Add Card'
                clickHandler={() => setOpenPaymentModal(true)}
              />
            </div>

            <div className='relative z-10 mb-6 overflow-visible'>
              <CardList cards={cardsListData ?? []} />
            </div>

            {defaultCardDetails !== null && (
              <div className='relative z-0 rounded-xl border border-slate-200/80 bg-white px-4 py-4 shadow-sm'>
                <p className='text-xs font-semibold uppercase tracking-wide text-slate-500 mb-3'>Default payment method</p>
                {stripeDefaultPaymentMethodLaoder ? (
                  <CircularLoader classes='flex justify-center items-center py-4' classloader='loader-l' />
                ) : (
                  <div className='grid gap-4 sm:grid-cols-3 text-sm'>
                    <div>
                      <span className='text-slate-500 block text-xs mb-0.5'>Card</span>
                      <span className='font-medium text-slate-800 font-mono'>•••• {defaultCardDetails?.last4}</span>
                    </div>
                    <div>
                      <span className='text-slate-500 block text-xs mb-0.5'>Name on card</span>
                      <span className='font-medium text-slate-800'>
                        {defaultCardDetails?.card_name ? capitalizeFirstLetter(defaultCardDetails.card_name) : "—"}
                      </span>
                    </div>
                    <div>
                      <span className='text-slate-500 block text-xs mb-0.5'>Expires</span>
                      <span className='font-medium text-slate-800'>
                        {String(defaultCardDetails?.exp_month ?? "").padStart(2, "0")}/{defaultCardDetails?.exp_year}
                      </span>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
      {openPaymentModal && (
        <ModalSkeleton
          cssClass='w-[35%]'
          title='Add Credit Card Details'
          isOpen={openPaymentModal}
          closeModal={() => setOpenPaymentModal(false)}
        >
          <div className='w-full flex justify-center items-center'>
            <StripePayment handleClose={() => setOpenPaymentModal(false)} />
          </div>
        </ModalSkeleton>
      )}
    </>
  );
};

export default PaymentMethod;
